import ShareBar from './share-bar'
export default ShareBar